import React from "react";

/**
 * Logo PEÇA AUTO NET — SVG vetorial.
 * Props:
 *   - size: altura em px (width é proporcional)
 *   - showText: se true, renderiza "PEÇA AUTO NET" abaixo do ícone
 *   - stacked: se true, texto embaixo; se false, texto ao lado (para navbar)
 */
export default function Logo({ size = 64, showText = true, stacked = true }) {
  const iconHeight = size;
  const iconWidth = size * 0.9;

  return (
    <div
      style={{
        display: "inline-flex",
        flexDirection: stacked ? "column" : "row",
        alignItems: "center",
        gap: stacked ? 12 : 10,
        lineHeight: 1,
      }}
      aria-label="PEÇA AUTO NET"
    >
      <svg
        width={iconWidth}
        height={iconHeight}
        viewBox="0 0 180 200"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="wrenchGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#4FC3F7" />
            <stop offset="100%" stopColor="#1B6FA8" />
          </linearGradient>
          <linearGradient id="arrowGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#7ED957" />
            <stop offset="100%" stopColor="#1F8C4A" />
          </linearGradient>
          <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
            <feOffset dx="0" dy="2" result="offsetblur" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.35" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* ==================== Chave de boca (azul) ==================== */}
        <g filter="url(#softShadow)">
          {/* cabeça da chave (U aberto) */}
          <path
            d="M 30 10
               L 30 45
               L 55 45
               L 55 30
               L 70 30
               L 70 45
               L 85 45
               L 85 10
               Z"
            fill="url(#wrenchGrad)"
          />
          {/* corpo vertical */}
          <rect x="48" y="45" width="20" height="115" rx="3" fill="url(#wrenchGrad)" />
          {/* slot alongado no corpo (vazado) */}
          <rect x="54" y="70" width="8" height="50" rx="3" fill="#1C1F26" />
          {/* base hexagonal (cabo inferior) */}
          <polygon
            points="48,160 68,160 78,175 68,190 48,190 38,175"
            fill="url(#wrenchGrad)"
          />
          <polygon
            points="54,168 62,168 66,175 62,182 54,182 50,175"
            fill="#1C1F26"
          />
        </g>

        {/* ==================== Seta verde (subida) ==================== */}
        <g filter="url(#softShadow)">
          {/* ponta da seta */}
          <polygon
            points="120,10 160,60 140,60 140,120 100,120 100,60 80,60"
            fill="url(#arrowGrad)"
          />
          {/* caule */}
          <rect x="105" y="120" width="30" height="60" rx="2" fill="url(#arrowGrad)" />
          {/* curva que faz o J */}
          <path
            d="M 105 180
               Q 105 190 120 190
               L 135 190
               Q 150 190 150 175
               L 150 160
               L 135 160
               L 135 175
               L 120 175
               Z"
            fill="url(#arrowGrad)"
          />
        </g>

        {/* ==================== Circuito central ==================== */}
        <g stroke="#7ED957" strokeWidth="2.2" fill="none">
          <path d="M 78 90 L 95 90" />
          <path d="M 78 110 L 88 110 L 88 125 L 98 125" />
          <path d="M 78 135 L 95 135" />
        </g>
        <g fill="#7ED957">
          <circle cx="78" cy="90" r="3" />
          <circle cx="95" cy="90" r="3" />
          <circle cx="78" cy="110" r="3" />
          <circle cx="98" cy="125" r="3" />
          <circle cx="78" cy="135" r="3" />
          <circle cx="95" cy="135" r="3" />
        </g>
      </svg>

      {showText && (
        <span
          style={{
            fontFamily: "'Rajdhani', 'Inter', sans-serif",
            fontWeight: 700,
            letterSpacing: "0.08em",
            color: "#FFFFFF",
            fontSize: stacked ? size * 0.28 : size * 0.38,
            textTransform: "uppercase",
            whiteSpace: "nowrap",
          }}
        >
          PEÇA AUTO NET
        </span>
      )}
    </div>
  );
}
